import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { AuthService } from "../../drive-adapter/user-service/auth.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if account is logged in and request is to the api url
        const isLoggedIn = this.authService.UserLoginResponse && this.authService.UserLoginResponse?.data?.token;
        const isApiUrl = request.url.startsWith(environment.apiUrl);

        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                setHeaders: { 
                    'Token': `${this.authService.UserLoginResponse?.data?.token}`,
                    'X-Forwarded-For': this.authService.PublicIPAddress,
                },
            });
        }
        //Set last activity for validate idle time when the token expires
        this.authService.setLastActivity();
        return next.handle(request);
    }
}